module.exports = __webpack_public_path__ + "7e4b29ba/img/file-icon.c085e21e.svg";